import React from 'react';
import { useParams, Link } from 'react-router-dom';
import '../../Assets/Styles/Pages/single_blog.css';
import AboutNav from '../../Components/Navigation/AboutNav';
import Footer from '../../Components/Home/Footer';
import SEBISlider from '../../Components/Common/SEBISlider';
import ISOCertificateButton from '../../Components/Common/ISOCertificateButton';
import { Helmet } from 'react-helmet';

const Single_blog = () => {
  const { id } = useParams();

  // This would typically come from an API or database
  const blogPosts = [
    {
      id: 1,
      title: "Market Analysis: Current Trends and Future Predictions",
      content: `
        <p>Welcome to our comprehensive market analysis blog, designed to provide valuable insights for investors and traders alike. Our team of professional analysts has been closely monitoring market indicators and patterns to provide you with valuable insights.</p>
        
        <h2>Current Market Trends</h2>
        <p>The market has shown significant volatility in recent months, with several key factors influencing price movements:</p>
        <ul>
          <li>Global economic recovery post-pandemic</li>
          <li>Technological advancements in trading platforms</li>
          <li>Shifts in consumer behavior and preferences</li>
          <li>Regulatory changes affecting market dynamics</li>
        </ul>

        <h2>Future Predictions</h2>
        <p>Based on our analysis, we anticipate several key developments in the coming months:</p>
        <ul>
          <li>Increased market stability as global economies recover</li>
          <li>Growth in sustainable and ESG-focused investments</li>
          <li>Expansion of digital asset trading opportunities</li>
          <li>Enhanced regulatory frameworks for market protection</li>
        </ul>

        <h2>Investment Strategies</h2>
        <p>To navigate these changes effectively, we recommend:</p>
        <ul>
          <li>Diversifying your investment portfolio</li>
          <li>Staying informed about market developments</li>
          <li>Utilizing advanced trading tools and analytics</li>
          <li>Maintaining a long-term investment perspective</li>
        </ul>
      `,
      date: "March 15, 2024",
      category: "Market Analysis",
      image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?q=80&w=2070",
      author: "John Doe",
      authorRole: "Senior Market Analyst"
    },
    // Add more blog posts as needed
  ];

  const post = blogPosts.find(post => post.id === parseInt(id));

  if (!post) {
    return (
      <div className="not-found">
        <AboutNav />
        <h2>Blog post not found</h2>
        <Link to="/blog" className="back-to-blog">Back to Blog</Link>
        <Footer />
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{post.title} | Trillion Stock Research Blog</title>
        <meta name="description" content={post.excerpt || post.content.replace(/<[^>]+>/g, '').slice(0, 150)} />
        <meta name="keywords" content={post.category + ', stock market, investment, Trillion Stock Research'} />
        <link rel="canonical" href={`https://www.trillionstockresearch.com/blog/${post.id}`} />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "headline": post.title,
          "image": post.image,
          "author": {
            "@type": "Person",
            "name": post.author
          },
          "publisher": {
            "@type": "Organization",
            "name": "Trillion Stock Research",
            "logo": {
              "@type": "ImageObject",
              "url": "https://www.trillionstockresearch.com/logo.png"
            }
          },
          "datePublished": post.date,
          "description": post.excerpt || post.content.replace(/<[^>]+>/g, '').slice(0, 150),
          "mainEntityOfPage": `https://www.trillionstockresearch.com/blog/${post.id}`
        })}</script>
      </Helmet>
      <div className="single-blog-page">
        <AboutNav />
        <SEBISlider />
        <div className="blog-hero" style={{ backgroundImage: `url(${post.image})` }}>
          <div className="hero-overlay">
            <div className="blog-container">
              <div className="blog-category">{post.category}</div>
              <h1>{post.title}</h1>
              <div className="blog-meta">
                <span className="date">{post.date}</span>
                <span className="author">{post.author} - {post.authorRole}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="blog-container">
          <article className="blog-content">
            <div dangerouslySetInnerHTML={{ __html: post.content }} />
          </article>

          <div className="blog-navigation">
            <Link to="/blog" className="back-to-blog">
              Back to All Posts
            </Link>
          </div>
        </div>
        <Footer />
        <ISOCertificateButton />
      </div>
    </>
  );
};

export default Single_blog;
